// Build-time configuration for the admin SPA.
//
// All Vite env vars are read once here; downstream modules import the
// resolved constants so they can be mocked in tests without touching
// import.meta.env.

export const kApiBaseUrl: string =
  import.meta.env.VITE_API_BASE_URL ?? 'https://api.mylastmessage.org'

export const kGoogleClientId: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''

export type FakeOperatorRole = 'admin' | 'operator' | 'viewer'

const rawFakeRole = (import.meta.env.VITE_FAKE_OPERATOR ?? '').toString()
const validFakeRoles: ReadonlySet<FakeOperatorRole> = new Set([
  'admin', 'operator', 'viewer',
])
export const kFakeOperatorRole: FakeOperatorRole | '' =
  validFakeRoles.has(rawFakeRole as FakeOperatorRole)
    ? (rawFakeRole as FakeOperatorRole)
    : ''

// Truthy only when a recognised dev role is configured. The LoginPage and
// AppShell render their dev-only chrome (the red bypass button + "DEV
// FAKE OPERATOR" banner) from this single source of truth so production
// builds tree-shake the entire fake path. `admin/deploy.sh` refuses to
// run when VITE_FAKE_OPERATOR is set, so this can never be true in prod.
export const kFakeOperatorEnabled: boolean = kFakeOperatorRole !== ''
